// extracted by mini-css-extract-plugin
export default {"ordersContentContainer":"Orders_ordersContentContainer__WvPl2"};